// third party
import { Component, inject, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
// local
import { DarkThemeService } from 'src/app/core/services/dark-theme/dark-theme.service';
import { HttpLoadingService } from 'src/app/core/services/http-loading/http-loading.service';
import { MenuOpenService } from 'src/app/core/services/menu-open/menu-open.service';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { GraphApiProfile } from '../../services/profile/graph-api-profile';
import { environment } from 'src/environments/environment';
import { ErrorStore } from '@stores';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { FeedbackDialogComponent } from 'src/app/shared/feedback-dialog/feedback-dialog.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  errorStore = inject(ErrorStore);
  readonly dialog = inject(MatDialog);
  
  public profile?: GraphApiProfile;
  public readonly applicationName: string = environment.applicationName;
  public readonly environmentName: string = environment.environmentName;
  // Colors the whole header bar per environment (Dev/Test/UAT) so it's never mistaken for
  // production, matching the pattern used by another internal app. Prod gets no override class,
  // so it keeps the default theme color.
  private static readonly ENVIRONMENT_BAR_CLASSES: Record<string, string> = {
    Dev: 'env-bar-dev',
    Test: 'env-bar-test',
    UAT: 'env-bar-uat'
  };
  public readonly environmentBarClass: string = NavbarComponent.ENVIRONMENT_BAR_CLASSES[environment.environmentName] ?? '';
  constructor(
    private authService: MsalService,
    public darkThemeService: DarkThemeService,
    public menuOpenService: MenuOpenService,
    private profileService: ProfileService,
    public loadingService: HttpLoadingService,
  ) { }

  ngOnInit(): void {
    this.profileService.getProfile().subscribe((profile) => {
      this.profile = profile;
    });
  }

  logout() {
      this.authService.logoutRedirect();
  }

  clickMenu () {
    this.menuOpenService.changeMenu();
  }

  changeTheme () {
    this.darkThemeService.changeTheme();
  }

  onErrorsButtonClick() {
    this.dialog.open(ErrorDialogComponent, {
      width: '1200px'
    });
  }

  onFeedbackButtonClick() {
    this.dialog.open(FeedbackDialogComponent, {
      width: '600px'
    });
  }
}
